import React, { useState, useEffect } from "react"
import Typography from "@mui/material/Typography"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import GalleryItem from "../gallery/gallery-item"

const GallerySlider = ({ galleryData, onChange }) => {
  const galleryItems = galleryData?.data || []
  const [filteredData, setFilteredData] = useState(galleryItems)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [selectedTitle, setSelectedTitle] = useState("")

  useEffect(() => {
    if (filteredData.length > 0) {
      onChange("media:" + filteredData[currentIndex].id)
    }
  }, [currentIndex, filteredData, onChange])

  const handleSearch = (title) => {
    setSelectedTitle(title)
    if (title === "") {
      setFilteredData(galleryItems)
      return
    }
    const filtered = galleryItems.filter((item) =>
      item.title.toLowerCase().includes(title.toLowerCase())
    )
    setFilteredData(filtered)
    setCurrentIndex(0)  
  }

  return (
    <>
      <div style={{ marginBottom: "1rem" }}>
        <Select
          value={selectedTitle}
          onChange={(e) => handleSearch(e.target.value)}
          displayEmpty
          style={{ width: "100%" }}
        >
          <MenuItem value="">All Titles</MenuItem>
          {galleryItems.map((item) => (
            <MenuItem key={item.id} value={item.title}>
              {item.title}
            </MenuItem>
          ))}
        </Select>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <div style={{ width: "80%", display: "flex", justifyContent: "center" }}>
          {filteredData.length > 0 ? (
            <GalleryItem {...filteredData[currentIndex]} />
          ) : (
            <div style={{color: 'var(--text-primary)'}}>No data to display</div>
          )}
        </div>
      </div>
    </>
  )
}

export default GallerySlider
